export class ShoppingCartAmountService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  async handle(params) {
    return await this.httpClient.get('/v01/pedidos/Lista', {
      params
    })
  }
}
